import React, { useState, useEffect } from 'react';
import $ from "jquery";
import Toastr from 'toastr';
// import bootbox from 'bootbox';
// import Loading from "../Loading";
// import ReactDOM from 'react-dom';
import '../../assets/css/videojs.css';
import Hls from 'hls.js';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

let player;

const LiveCameraFeed = (props) => {
    const [dataEndPoint, setDataEndPoint] = useState(null);

    let hls_container = '#LIVE_CAM_' + (props.zone.location_id);
    let browserAgent = (navigator.userAgent).toUpperCase();
    let iOS = browserAgent.includes('IPAD') || browserAgent.includes('IPHONE');
    let video_container_id = 'video-container-' + props.zone.location_id + '-' + props.zone.device_id;
    let video_hls_id = 'video-hls-' + props.zone.location_id + '-' + props.zone.device_id;

    useEffect(() => {
        startLiveCameraFeed();
    }, []);


    let manageCameraFeed = async (operation, extraAtts = {}) => {
        return new Promise(function (resolve, reject) {
            var data = {
                user_login: props.user.user_login,
                user_token: props.user.user_token,
                form_input: { operation: operation, device_id: props.zone.device_id, ...extraAtts }
            }

            CommonUtils.ajax(
                {
                    url: API.CAMERA.LIVE_FEED,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res.status) {
                        if (res.status.code === 200 || res.status.code === 201)
                            resolve(res.data);
                        else
                            resolve(null);
                    } else {
                        resolve(null);
                    }
                },
                (error) => {
                    resolve(null);
                }
            );
        });
    }

    let startLiveCameraFeed = async () => {
        $(hls_container).find('.btn-try-again').addClass('hide');
        $(hls_container).find('video').addClass('hide');
        $(hls_container).find('.message-container').removeClass('hide');
        $(hls_container).find('.message').html('<i class="fa fa-lg fa-spin fa-circle-notch text-app"></i> Preparing Streaming ...');

        let deviceState = await manageCameraFeed('start-feed');
        if (deviceState && deviceState.payload) {
            let cameraFeed;
            let attempts = 20;
            while (!cameraFeed && attempts > 0) {
                cameraFeed = await manageCameraFeed('stream-url');
                if (cameraFeed && cameraFeed.code === 'ResourceNotFoundException') {
                    attempts = 0;
                } else {
                    if (!cameraFeed || !cameraFeed.HLSStreamingSessionURL) {
                        cameraFeed = null;
                        await sleep(5000);
                    }
                    attempts--;
                }
            }

            if (cameraFeed) {
                if (cameraFeed.code === 'ResourceNotFoundException') {
                    $(hls_container).find('.message').html('<i class="fa fa-lg fa-info-circle text-app"></i> No active LIVE feed available ...');
                } else {
                    $(hls_container).find('.message-container').addClass('hide');
                    $(hls_container).find('video').removeClass('hide');
                    let DataEndpoint = cameraFeed.endpoint;
                    setDataEndPoint(DataEndpoint);
                    $('.save-clip').removeClass('hide');
                    playHLSVideo(cameraFeed.HLSStreamingSessionURL);
                }
            } else {
                $(hls_container).find('.message').html('<i class="fa fa-lg fa-info-circle text-app"></i> Unable to retrieve LIVE feed ...');
                $(hls_container).find('.btn-try-again').removeClass('hide');
            }
        } else {
            $(hls_container).find('.message').html('<i class="fa fa-lg fa-info-circle text-app"></i> No LIVE feed available');
        }
    }


    let playHLSVideo = async (stream_url) => {
        $('#' + video_container_id).html('<video id="' + video_hls_id + '" width="100%" id="video" controls="true"></video>');
        var video = document.getElementById(video_hls_id);
        if (Hls.isSupported()) {
            var hls = new Hls({
                debug: true,
            });
            hls.loadSource(stream_url);
            hls.attachMedia(video);
            hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                video.muted = true;
                video.play();
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            $('#' + video_container_id).html("<video controls style='objectFit: cover' id='" + video_hls_id + "' class='video-js vjs-theme-city vjs-big-play-centered hide' />");
            if (!window.videojs)
                return setTimeout(playHLSVideo(stream_url), 3000);

            player = window.videojs('#' + video_hls_id);
            setTimeout(() => {
                player.ready(function () {
                    this.src({
                        src: stream_url,
                        type: 'application/x-mpegURL'
                    });
                    $('#' + video_hls_id).removeClass('hide');
                    $('#' + video_hls_id + ' .vjs-big-play-button').trigger('click');
                });
            }, iOS ? 5000 : 0);
        }
    }

    // stopLiveCamerFeed = async () => {
    //     let _this = this;
    //     if (this.DataEndpoint) {
    //         bootbox.confirm({
    //             message: 'Would you like to save video before you leave ?',
    //             buttons: {
    //                 confirm: {
    //                     label: 'Yes, Please ...'
    //                 },
    //                 cancel: {
    //                     label: 'No'
    //                 }
    //             },
    //             callback: async (isYes) => {
    //                 if (isYes) {
    //                     ReactDOM.render(<Loading className="text-white" transparent={true}>Saving video...</Loading>, $('.modal-title')[0]);
    //                     await _this.saveClip();
    //                 } else {
    //                     this.DataEndpoint = null;
    //                 }
    //                 this.closeWindow(_this);
    //             }
    //         });
    //     } else {
    //         this.closeWindow(_this);
    //     }
    // }

    let closeWindow = async (_this) => {
        try {
            if (player) {
                player.dispose();
            }
        } catch (e) { }
        props.closeModal();
        await manageCameraFeed('stop-feed');

        if ($('.streaming-btn'))
            $('.streaming-btn').trigger('click');
    }

    let saveClip = async () => {

        Toastr.success('Saving in progress...');
        $('.save-clip').prop('disabled', true);
        let extraAtts = {
            DataEndpoint: dataEndPoint,
            customer_id: props.zone.customer_id,
            site_id: props.zone.site_id,
            location_id: props.zone.location_id
        };
        let result = await manageCameraFeed('save-clip', extraAtts);
        if (result) {
            closeWindow(this);
            Toastr.success('Video is saved and available in the video library.');
        } else {
            closeWindow(this);
            Toastr.error('Error while saving video ...');
        }


    }

    let sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    return (

        <React.Fragment>

            <div className="modal-header p-2 bg-primary text-white ">
                <span className="modal-title">{"Watch Streaming Video - " + props.zone.location_name}</span>
                <span className='pull-right'>
                    {/* <button type='button' className='far fa-lg fa-save hide save-clip-btn' onClick={saveClip}></button> */}
                    <button type='button' id='close-player' className='far fa-lg fa-times-circle save-clip' data-dismiss='modal' onClick={saveClip}></button>
                </span>
            </div>
            <div className="modal-body p-1" id={'LIVE_CAM_' + (props.zone.location_id)} >
                <React.Fragment>
                    <div className="text-center message-container" style={{ padding: "200px 0px" }}>
                        <div>
                            <span className="border-rounded p-2 message bg-primary-light" ><i className="fa fa-lg fa-spin fa-circle-notch text-app"></i> Preparing Streaming ...</span><br />
                            <button className="btn btn-sm btn-primary hide btn-try-again mt-2" onClick={startLiveCameraFeed}>Try again</button>
                        </div>
                    </div>
                    <div style={{ width: '100%' }} id={video_container_id}></div>
                    <div id="status"></div>
                </React.Fragment>
            </div>

        </React.Fragment>

    );
}

export default LiveCameraFeed;